var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.571,
    height: 19,
    viewBox: "0 0 15.571 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_20795",
    "data-name": "Group 20795",
    transform: "translate(-0.566 -0.707)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20731",
    "data-name": "Group 20731",
    transform: "translate(1.066 1.207)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_204",
    "data-name": "Ellipse 204",
    cx: 1.995,
    cy: 1.995,
    r: 1.995,
    transform: "translate(5.291 4.895)",
    fill: "#44546f",
    stroke: "#44546f",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21890",
    "data-name": "Path 21890",
    d: "M8.286,19s7.286-6.5,7.286-10.714A7.286,7.286,0,1,0,1,8.286C1,12.5,8.286,19,8.286,19Z",
    transform: "translate(-1 -1)",
    fill: "none",
    stroke: "#44546f",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationCard);
export default __webpack_public_path__ + "static/media/location-card.a4264960d147850ef5e87da65b45cd50.svg";
export { ForwardRef as ReactComponent };